module.exports = __webpack_public_path__ + "img/omja.a0edaad1.png";